// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';



class AddLeadBulk extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      file_formats:[],
      msg_success:[],
      msg_warning:[],
      msg_info :[],
      msg_error:[],
      file_format:'',
      data_sources:[],
      data_source:'',
      file : null    
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.post_lead_bulk = this.post_lead_bulk.bind(this);
    this.fileHandler = this.fileHandler.bind(this);

  }


  componentDidMount() {
    this.getDetailsForLeadData();
    

    // // TODO: remove after testing
    // this.setPostSubscriptions();
  }


  getDetailsForLeadData() {
     const url = `${getLocationOrigin()}/lead/get_details_for_bulklead/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({data_sources: data.lead_source, file_formats : data.fileformats ,
                          data_source : data.lead_source[0][0]  ,file_format : data.fileformats[0][0] });
           // this.setState({reason:data.reasons[0]})

       }).catch(error => error);
  }

  
  

  post_lead_bulk(){
    const url = `${getLocationOrigin()}/lead/add_lead_in_bulk/`;
                const options = {...defaultOptions};
                var formData = new FormData();
                formData.append('file', this.state.file);
                formData.append('fileformats',this.state.file_format);
                formData.append('upload_sources',this.state.data_source);
                options['method'] = 'post';

                options['body'] = formData;
                console.log('Going to fetch');
    return fetch(url, options)
                .then(checkStatus)
                .then(parseJSON)
                .then((response) => {
                    console.log(response)
                    if(response.Success == 'True'){
                    this.setState({msg_success:response.msg_success,
                                  msg_warning:response.msg_warning,
                                  msg_info :response.msg_info,
                                  msg_error:response.msg_error});   }
                    else{
                      alert(response.Message);
                    }                
                                       
                })
                .catch(error => {
                    console.log(error);
                    alert(error.message);
                });
  }

  fileHandler = (event) => {
    let fileObj = event.target.files[0];
    this.setState({file :fileObj});
    this.btn.removeAttribute("disabled");
  }

  

  
  


  handleChange(event) {
    const name = event.target.name;
    if (name=="file_format"){
        
        this.setState({file_format:event.target.value});
      }
    else if (name =='data_source'){
          
          this.setState({data_source:event.target.value});
        }    
  }

  handleSubmit(event) {
    event.preventDefault();
    this.btn.setAttribute("disabled", "disabled");
    this.post_lead_bulk();    
    console.log('post');
    console.log(this.state);
    
    
  }
  render() {
    console.log(this.state)

    return(
      <div>
      <div style={{...styles.container}}>
        
            <div className="row col-md-8 table-bordered" style={styles.table}>
              <div style={styles.main_header} className="col-md-12">
                <h3 style={{textAlign:'center'}}>Add Leads Bulk</h3>
              </div>
              <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    File Format
                  </div>
                  <div className="col-md-6" style={{width:'60%'}}>
                  <select name="file_format" className="col-md-6" style={styles.item_body} value={this.state.file_format}
                    onChange={this.handleChange}>
                    {
                      this.state.file_formats.map((x, index) => (
                      <option key={x.id} value={x[0]} >{`${x[1]}`}</option>
                      ))
                    }
                  </select>
                  </div>
                  
                </div>
               <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Data Source
                  </div>
                  <div className="col-md-6" style={{width:'60%'}}>
                  <select name="data_source" className="col-md-6" style={styles.item_body} value={this.state.data_source}
                    onChange={this.handleChange}>
                    {
                      this.state.data_sources.map((x, index) => (
                      <option key={x.id} value={x[0]} >{`${x[1]}`}</option>
                      ))
                    }
                  </select>
                  </div>
                  
                </div>
                <div style={styles.button_submit} className="col-md-12">
                  
                  <input type="file" className="col-md-6" onChange={this.fileHandler.bind(this)} style={{"padding":"10px",'width':'55%'}} />
                  
                  <input className="btn btn-lg" ref={btn => { this.btn = btn; }}  onClick={this.handleSubmit} type="button" value="Upload " style={{
                      backgroundColor:'#302C35',
                      backgroundColor:'#009688',
                      color:'#ffffff'
                  }}/>


                </div>
              </form>
            </div>
        
          
        
      </div>
      <div className="col-md-12">
                <div className="col-md-12">
                    {this.state.msg_success.map( (x) =>(
                      <div className="col-md-12"
                    style={{padding:'1%',background: '#3fd987', border: '1px solid #ddd', margin: '1px'}} >
                    {x}</div>))
                    }
                </div>
                <div className="col-md-12">
                    {this.state.msg_warning.map( (x) =>(
                      <div className="col-md-12"
                    style={{padding:'1%',background: '#d4d93f', border: '1px solid #ddd', margin: '1px'}} >
                    {x}</div>))
                    }
                </div>
                <div className="col-md-12">
                    {this.state.msg_error.map( (x) =>(
                      <div className="col-md-12"
                    style={{padding:'1%',background: 'orange', border: '1px solid #ddd', margin: '1px'}} >
                    {x}</div>))
                    }
                </div>
                <div className="col-md-12">
                    {this.state.msg_info.map( (x) =>(
                      <div className="col-md-12"
                    style={{padding:'1%',background: '#0ddbff', border: '1px solid #ddd', margin: '1px'}} >
                    {x}</div>))
                    }
                </div>
      </div>
    </div>
    );
  }
}

export default AddLeadBulk;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addLeadBulk/index.js